
import React from 'react';
import { Link } from 'react-router-dom';
import CookieSettingsLink from './cookie-consent/CookieSettingsLink';
import { Separator } from './ui/separator';
import { cityGroups, getStadNameFromSlug } from '@/data/cities';

const Footer = () => {
  return <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="flex flex-col">
            <div className="mb-4">
              <Link to="/" className="text-xl font-bold text-white tracking-wide">Afsprakenmaker</Link>
            </div>
            <p className="text-gray-400 mb-4">Wij vullen jouw agenda met 
warme afspraken zodat jij 
kan doen waar je goed in bent: 
klanten helpen en je bedrijf 
laten groeien.</p>
            <div className="flex gap-4 mt-auto">
              <a href="https://www.linkedin.com/company/am-theappointmentmakingcompany-afsprakenmaker" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </a>
              <a href="https://www.facebook.com/Afsprakenmaker/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-3 7h-1.924c-.615 0-1.076.252-1.076.889v1.111h3l-.238 3h-2.762v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" />
                </svg>
              </a>
            </div>
          </div>
          
          <div className="flex flex-col h-full">
            <h3 className="font-semibold text-lg mb-4">Diensten</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/diensten" className="text-gray-400 hover:text-white transition-colors">
                  Telefonische Prospectie
                </Link>
              </li>
              <li>
                <Link to="/diensten" className="text-gray-400 hover:text-white transition-colors">
                  Afspraken Inplannen
                </Link>
              </li>
              <li>
                <Link to="/diensten" className="text-gray-400 hover:text-white transition-colors">
                  CRM Integratie
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-gray-400 hover:text-white transition-colors">
                  Lead Calculator
                </Link>
              </li>
              <li>
                <Link to="/diensten" className="text-gray-400 hover:text-white transition-colors">
                  Sales Outsourcing
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="flex flex-col h-full">
            <h3 className="font-semibold text-lg mb-4">Kennisbank</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/over-ons" className="text-gray-400 hover:text-white transition-colors">
                  Succesverhalen
                </Link>
              </li>
            </ul>
          </div>
          
          <div className="flex flex-col h-full">
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-3 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>
                  Moorselbaan 391<br />
                  9300 Aalst
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                <span>+32 53 68 25 21</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <span>info@afsprakenmaker.be</span>
              </li>
            </ul>
            <div className="mt-4">
              <Link to="/contact" className="bg-brand-blue py-2 px-4 rounded text-white font-medium inline-block hover:bg-opacity-90 transition-colors">
                Contact Opnemen
              </Link>
            </div>
          </div>
        </div>
        
        {/* Steden sectie */}
        <div className="border-t border-gray-800 pt-8 pb-6">
          <h4 className="text-sm font-semibold text-gray-300 mb-4">Callcenter diensten in heel Vlaanderen:</h4>
          
          {Object.entries(cityGroups).map(([region, slugs]) => (
            <div key={region} className="mb-6">
              <h5 className="text-xs font-medium text-gray-400 mb-2">{region}:</h5>
              <div className="flex flex-wrap gap-y-1 gap-x-3">
                {slugs.map(slug => (
                  <Link
                    key={slug}
                    to={`/diensten/${slug}`}
                    className="text-gray-400 hover:text-gray-300 text-xs py-1"
                    aria-label={`Callcenter diensten in ${getStadNameFromSlug(slug)}`}
                  >
                    {getStadNameFromSlug(slug)}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        {/* Credibility Line - with equal spacing above and below */}
        <div className="text-center text-sm text-gray-400 py-4 border-t border-gray-800">
          <p className="my-4">Bijna 15 jaar ervaring – Trends Gazellen genomineerd – 100% gebootstrapped – Made in Vlaanderen</p>
        </div>
        
        <div className="pt-4 border-t border-gray-800 text-center text-gray-400 text-sm">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <Link to="/over-ons" className="hover:text-white transition-colors">
              Over Ons
            </Link>
            <Link to="/leadgeneratie-kmo" className="hover:text-white transition-colors">
              Ontdek onze aanpak
            </Link>
            <Link to="/producten" className="hover:text-white transition-colors">
              AM Intelligence
            </Link>
            <Link to="/privacybeleid" className="hover:text-white transition-colors">
              Privacybeleid
            </Link>
            <Link to="/algemene-voorwaarden" className="hover:text-white transition-colors">
              Algemene Voorwaarden
            </Link>
            <Link to="/cookiebeleid" className="hover:text-white transition-colors">
              Cookiebeleid
            </Link>
            <CookieSettingsLink className="cursor-pointer" />
          </div>
          <p suppressHydrationWarning>
            &copy; {new Date().getFullYear()} Afsprakenmaker | Alle rechten voorbehouden
          </p>
        </div>
      </div>
    </footer>;
};

export default Footer;
